import { Suspense, lazy } from 'react';
import { DendromapLoader } from '@repo/ui/components/dendromap-loader';

const SubscriptionHelperPage = lazy(() =>
  import('@repo/ui/features/subscription-helper/subscription-helper-page').then((module) => ({
    default: module.SubscriptionHelperPage,
  })),
);

export default function SubscriptionHelperDebugRoute() {
  return (
    <Suspense fallback={<DendromapLoader message="Chargement du subscription helper..." />}>
      <SubscriptionHelperPage />
    </Suspense>
  );
}
